import ClientsList from "./clients-list";

export default ClientsList;
